import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactModal from 'react-modal';
import InputMask from 'react-input-mask';
import { IoClose } from 'react-icons/io5';

import { useAuth } from 'context/AuthContext';
import Box from 'components/ui/box';
import { getPlayerInfo } from 'services/dashboard.service';
import FeedbackImg from 'assets/img/comportamento/bg-feedback-moedas.png';

import { User } from 'types/user';

import axios from 'axios';
import { getAddress, saveAddress } from 'services/store.service';

interface IAddress {
  onClose: () => void;
  onConfirm: () => void;
  data: any;
}

export default function Modal({ onClose, onConfirm, data }: IAddress) {
  const navigate = useNavigate();
  const { user, refreshUser } = useAuth();

  const [isOpen, setIsOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [name, setName] = useState('');
  const [address, setAddress] = useState('');
  const [complement, setComplement] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [cep, setCep] = useState('');
  const [number, setNumber] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  const [mask, setMask] = useState('(99) 9999-9999');
  const [phoneError, setPhoneError] = useState(false);
  const [cepError, setCepError] = useState(false);

  const [step, setStep] = useState(0);

  ReactModal.setAppElement('#modal');

  async function handleSubmit(e: any) {
    e?.preventDefault();

    if (phone.replace(/[^\d]/g, '').length < 8) {
      setPhoneError(true);
    }

    if (cep.replace(/[^\d]/g, '').length !== 8) {
      setCepError(true);
    }

    if (phoneError || cepError) {
      return;
    }

    if (step === 0) {
      setStep(1);
      return;
    }

    try {
      if (loading || !user?._id) return;

      setLoading(true);

      const payload = {
        _id: user._id,
        name,
        email,
        phone: phone?.replace('-', '')?.replace('(', '')?.replace(')', '')?.replace(' ', '')?.replace('_', ''),
        address,
        complement,
        city,
        state,
        cep: cep?.replace('-', ''),
        number,
      };

      await saveAddress(payload);
      setSubmitted(true);
      onConfirm();
    } finally {
      setLoading(false);
    }
  }

  const handleCepChange = async (e: any) => {
    setCep(e.target.value);
    if (e.target.value.length === 9 && !e.target.value.includes('_')) {
      const response = await axios.get(`https://viacep.com.br/ws/${e.target.value.replace('-', '')}/json/`);
      setAddress(response.data.logradouro);
      setCity(response.data.localidade);
      setState(response.data.uf);
    }
  };

  const handleCloseModal = () => {
    onClose();
  };

  const afterOpenModal = async () => {
    if (!user) return;

    const _address = data;
    if (_address) {
      setName(_address.name);
      setAddress(_address.address);
      setComplement(_address.complement);
      setCity(_address.city);
      setState(_address.state);
      setCep(_address.cep);
      setNumber(_address.number);
      setEmail(_address.email);
      setPhone(_address.phone);
    }
  };

  return (
    <ReactModal
      key={'modal-player-get-player'}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      isOpen={isOpen}
      onAfterOpen={afterOpenModal}
      onAfterClose={handleCloseModal}
      contentLabel="Modal Convidar Amigos"
      portalClassName="modal-player-get-player"
      overlayClassName="fixed z-20 top-0 left-0 w-full h-full bg-black bg-opacity-80 flex flex-col items-center justify-center"
      contentElement={() => (
        <>
          {!submitted && (
            <Box className="w-[90%] lg:max-w-screen-md">
              <div className="mx-auto relative container  max-h-[85vh]">
                <div className="block mb-8">
                  <h1 className="text-lg uppercase block text-center text-yellow">Cadastre o endereço de entrega</h1>
                  {step === 0 && (
                    <p className="text-center mt-2">
                      Cadastre um endereço que tenha pessoas para receber o presente em horário comercial.
                    </p>
                  )}
                </div>

                {!loading && !submitted && (
                  <div className="space-y-8">
                    <div className="space-y-6">
                      <div className="space-x-4 flex flex-row items-center justify-between w-full">
                        <div className="relative flex-1">
                          {/* <span className="text-alice-blue mb-4 block text-base font-thin">
                              O que é bom a gente compartilha! <br />A cada amigo que entrar no Reconheça BRB com seu convite, você
                              recebe <strong className="text-electric-blue font-normal">5 gigabytes</strong>.
                            </span> */}

                          <>
                            <div className="">
                              <form className="space-y-2" onSubmit={handleSubmit}>
                                <div>
                                  <input
                                    type="text"
                                    name="name"
                                    placeholder="Nome"
                                    required
                                    disabled={step > 0}
                                    value={name}
                                    onChange={e => setName(e.target.value)}
                                    className="w-full bg-maastricht-blue text-white text-sm font-light flex-1 rounded-md py-2 px-4"
                                  />
                                </div>

                                <div>
                                  <input
                                    type="email"
                                    name="email"
                                    placeholder="Email"
                                    required
                                    disabled={step > 0}
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    className="w-full bg-maastricht-blue text-white text-sm font-light flex-1 rounded-md py-2 px-4"
                                  />
                                </div>
                                <div>
                                  {/* <InputMask
                                    placeholder="Telefone"
                                    className="w-full bg-maastricht-blue text-white text-sm font-light flex-1 rounded-md py-2 px-4"
                                    mask={mask}
                                    value={phone}
                                    disabled={step > 0}
                                    onChange={e => {
                                      setPhone(e.target.value);
                                      if (e.target.value.replace(/[^\d]/g, '').length < 10) {
                                        setPhoneError(true);
                                      } else {
                                        setPhoneError(false);
                                      }
                                    }}
                                    onBlur={e => {
                                      if (e.target.value.replace('_', '').length === 14) {
                                        setMask('(99) 9999-9999');
                                      }
                                    }}
                                    onFocus={() => {
                                      setMask('(99) 99999-9999');
                                    }}
                                  > */}
                                  {/* <input type="tel" /> */}
                                  {/* </InputMask> */}
                                  {/* <InputMask
                                    placeholder="Telefone"
                                    value={phone}
                                    onChange={e => setPhone(e.target.value)}
                                    disabled={step > 0}
                                    required
                                    className="w-full bg-maastricht-blue text-white text-sm font-light flex-1 rounded-md py-2 px-4"
                                    mask="(99) 99999-9999"
                                    maskChar={null}
                                  ></InputMask> */}
                                </div>

                                <div>
                                  <InputMask
                                    mask="99999-999"
                                    name="cep"
                                    placeholder="CEP"
                                    value={cep}
                                    required
                                    disabled={step > 0}
                                    onChange={e => {
                                      handleCepChange(e);
                                      if (e.target.value.replace(/[^\d]/g, '').length !== 8) {
                                        setCepError(true);
                                      } else {
                                        setCepError(false);
                                      }
                                    }}
                                    alwaysShowMask={false}
                                    className="w-full bg-maastricht-blue text-white text-sm font-light flex-1 rounded-md py-2 px-4"
                                  />
                                </div>

                                <div>
                                  <input
                                    type="text"
                                    name="address"
                                    placeholder="Endereço"
                                    required
                                    disabled={step > 0}
                                    value={address}
                                    onChange={e => setAddress(e.target.value)}
                                    className="w-full bg-maastricht-blue text-white text-sm font-light flex-1 rounded-md py-2 px-4"
                                  />
                                </div>

                                <div>
                                  <input
                                    type="number"
                                    name="number"
                                    placeholder="Número da residência"
                                    required
                                    disabled={step > 0}
                                    value={number}
                                    onChange={e => setNumber(e.target.value)}
                                    className="w-full bg-maastricht-blue text-white text-sm font-light flex-1 rounded-md py-2 px-4"
                                  />
                                </div>

                                <div>
                                  <input
                                    type="text"
                                    name="complement"
                                    placeholder="Complemento"
                                    required
                                    disabled={step > 0}
                                    value={complement}
                                    onChange={e => setComplement(e.target.value)}
                                    className="w-full bg-maastricht-blue text-white text-sm font-light flex-1 rounded-md py-2 px-4"
                                  />
                                </div>

                                <div>
                                  <input
                                    type="text"
                                    name="city"
                                    placeholder="Cidade"
                                    required
                                    disabled
                                    value={city}
                                    onChange={e => setCity(e.target.value)}
                                    className="w-full bg-maastricht-blue text-white text-sm font-light flex-1 rounded-md py-2 px-4"
                                  />
                                </div>
                                <div>
                                  <input
                                    type="text"
                                    name="state"
                                    placeholder="Estado"
                                    disabled
                                    required
                                    value={state}
                                    onChange={e => setState(e.target.value)}
                                    className="w-full bg-maastricht-blue text-white text-sm font-light flex-1 rounded-md py-2 px-4"
                                  />
                                </div>

                                {step === 0 && (
                                  <>
                                    {cepError && (
                                      <p className="text-yellow mt-5 text-center">O CEP deve ter exatamente 8 dígitos.</p>
                                    )}
                                    {phoneError && (
                                      <p className="text-yellow mt-5 text-center">O telefone deve ter pelo menos 8 dígitos.</p>
                                    )}
                                  </>
                                )}

                                {/* {step === 1 && (
                                  <div className="pt-4">
                                    <p>
                                      Cadastre um endereço que tenha pessoas para receber o presente em horário comercial.
                                      Confirma o endereço acima?
                                    </p>
                                  </div>
                                )} */}

                                <div className="w-full flex justify-center pt-5 space-x-4">
                                  {step > 0 && (
                                    <button
                                      onClick={() => setStep(step - 1)}
                                      className={`leading-none ring-2 ring-blue-violet-crayola w-full lg:w-auto flex flex-col lg:flex-row items-center bg-transparent text-center text-white rounded py-3 px-4`}
                                    >
                                      <p className="font-bold text-sm leading-none uppercase">Não, quero alterar</p>
                                    </button>
                                  )}
                                  <button
                                    // disabled={!target?.length}
                                    // onClick={() => (target?.length ? handleSubmit() : null)}
                                    type="submit"
                                    className={`leading-none disabled:opacity-50 ring-2 ring-slate-blue w-full lg:w-auto flex flex-col lg:flex-row items-center bg-slate-blue text-center text-white rounded py-3 px-4`}
                                  >
                                    <p className="font-bold text-sm leading-none uppercase">
                                      {step === 0 ? 'Continuar' : 'Sim, cadastrar'}
                                    </p>
                                  </button>
                                </div>
                              </form>
                            </div>
                          </>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {loading && !submitted && (
                  <div className="space-y-4 mt-12">
                    <div className="flex flex-row items-center justify-center text-xl text-yellow animate-pulse">
                      <div></div>
                      Salvando endereço...
                    </div>
                  </div>
                )}
              </div>
            </Box>
          )}

          {submitted && (
            <div className="border-2 rounded-3xl p-3 relative bg-oxford-blue border-electric-blue p-8 flex flex-col w-[324px] lg:max-w-screen-md justify-center items-center">
              <button
                className="absolute w-[33px] h-[33px] flex items-center justify-center -top-4 -right-4 button-close bg-slate-blue rounded-full"
                onClick={() => {
                  if (loading) return null;

                  setIsOpen(false);
                }}
              >
                <IoClose size={23} className="text-white leading-none block m-0 p-0" />
              </button>

              <div className="flex flex-col items-center justify-center">
                <div className="flex items-center justify-center mb-6">
                  <img src={FeedbackImg} alt="Enviado!" className="w-[173px] block" />
                </div>

                <h1 className="block text-2xl font-semibold text-yellow mb-4 text-center">Endereço salvo!</h1>
              </div>
            </div>
          )}
        </>
      )}
    />
  );
}
